// extracted by mini-css-extract-plugin
export default {"container":"article_create_container__TdOxW","minus_icon_container":"article_create_minus_icon_container__ciL14","dragger":"article_create_dragger__qeSg6"};